import { z } from "zod";

export const searchParamsSchema = z.object({
	page: z.coerce.number().default(1).catch(1),
	dir: z.enum(["ASC", "DESC"]).default("ASC").catch("ASC"),
	sort: z.string().optional().default("name").catch("name"),
	limit: z.coerce.number().optional().catch(32),
	mode: z.enum(["grid", "list"]).default("grid").catch("grid"),
});

export type SearchParamsSchemaType = z.TypeOf<typeof searchParamsSchema> & {
	[key: string]: string;
};
